import React from 'react';

/**
 * DashboardLegend component
 * Displays a color legend for specific vehicle statuses/types on the dashboard.
 */
const DashboardLegend = () => {
    const legendItems = [
        { label: 'Unidades en salida', color: 'bg-red-500' },
        // { label: 'No mayoreados', color: 'bg-blue-500' },
        { label: 'Unidades facturadas', color: 'bg-yellow-500' },
    ];

    return (
        <div className="flex justify-end mb-3 sm:mb-4 px-2">
            <div className="flex flex-wrap items-center justify-end gap-x-3 gap-y-1 sm:gap-x-6 sm:gap-y-1.5">
                {legendItems.map((item, index) => (
                    <div key={index} className="flex items-center gap-1 sm:gap-2">
                        <span className={`w-2 h-2 sm:w-3 sm:h-3 rounded-full ${item.color} shrink-0`} aria-hidden="true" />
                        <span className="text-[9px] sm:text-xs font-medium text-gray-600">{item.label}</span>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default DashboardLegend;